import * as React from "react";
import { Drawing } from "./Canvas/Drawing";
import { Dialog, Pane } from "evergreen-ui";
export let DrawingDlg = (props) => {
    let [size, setSize] = React.useState({ width: props.Width, height: props.Height, open: false, style: {} });
    function onclick() {
        if (size.open) {
            size.open = false;
            size.width = props.Width;
            size.height = props.Height;
            size.style = {};
        }
        else {
            size.open = true;
            size.width = window.innerWidth / 2;
            size.height = window.innerWidth / 2;
            // size.style = {
            //   zIndex: 100000,
            //   top: 10,
            //   left: (window.innerWidth / 2) - (size.width / 2),
            //   position: "absolute",
            //   background: "white",
            // };
        }
        setSize(Object.assign({}, size));
    }
    return (React.createElement(React.Fragment, null,
        size.open &&
            React.createElement(Dialog, { isShown: size.open, title: "Preview", onCloseComplete: () => { onclick(); }, shouldCloseOnOverlayClick: false, hasFooter: false, width: "100%" },
                React.createElement(Pane, { display: "flex", alignItems: "center", justifyContent: "center" },
                    React.createElement(Drawing, Object.assign({}, props, { Width: size.width, Height: size.height, onClick: (e) => {
                            onclick();
                        }, style: size.style })))),
        React.createElement(Drawing, Object.assign({}, props, { 
            // Width={size.width}
            // Height={size.height}
            onClick: (e) => {
                onclick();
            }, style: size.style }))));
};
